import Vue from 'vue';
import Vuex from 'vuex';
import cookie from 'vue-cookie'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    content: {
      'nl': null, 
      'de': null, 
      'en': null
    },
    locale: 'nl',
    drawing: null,
    drawings: JSON.parse(cookie.get('invention_drawings')),
    invention_app_inited: false,
    invention: null,
    invention_id: null,
    drawings_count: 0,
    chroma_key_color: cookie.get('invention_chroma_key_color') ? cookie.get('invention_chroma_key_color') : '#20965d',
    chroma_key_sensitivity: cookie.get('invention_chroma_key_sensitivity') ? cookie.get('invention_chroma_key_sensitivity') : 50,
    pusherGreenScreenInitiated: false,
    pusherTabletInitiated: false
  },
  getters: {
    content: state => {
      return state.content[state.locale] ? state.content[state.locale][0] : null
    },
    locale: state => {
      return state.locale
    },
    drawings: state => {
      let drawings = state.drawings;

      if(!drawings) {
        drawings = [];
      }

      return drawings;
    },
    currentDrawing: (state, getters) => {
      return getters.drawings[0];
    },
    hasDrawings: (state, getters) => {
      return getters.drawings.length > 0;
    },
    drawingsCount: (state, getters) => {
      return getters.drawings.length;
    },
    chromaKeyColorRGBArray: state => {
      const r = parseInt(state.chroma_key_color.substr(1,2), 16);
      const g = parseInt(state.chroma_key_color.substr(3,2), 16);
      const b = parseInt(state.chroma_key_color.substr(5,2), 16);
      return [r, g, b];
    }
  },
  mutations: {
    updateContent: (state, payload) => {
      state.content[payload.locale] = payload.data
    },
    locale(state, language) {
      state.locale = language;
    },
    drawing(state, drawing) {
      state.drawing = drawing;
    },
    addDrawing(state, drawing) {
      if(!state.drawings) {
        state.drawings = [];
      }

      state.drawings.push(drawing);

      cookie.set('invention_drawings', JSON.stringify(state.drawings));
    },
    invention(state, invention) {
      state.invention = invention;
    },
    inventionId(state, inventionId) {
      state.invention_id = inventionId;
    },
    removeCurrentDrawing(state) {
      state.drawings.shift();

      cookie.set('invention_drawings', JSON.stringify(state.drawings));
    },
    drawings_count(state, count) {
      state.drawings_count = count;
    },
    chroma_key_color(state, rgbArray) {
      let rgbToHex = function (rgb) {
        var hex = Number(rgb).toString(16);
        if (hex.length < 2) {
             hex = "0" + hex;
        }
        return hex;
      };
      state.chroma_key_color = "#" + rgbToHex(rgbArray[0]) + rgbToHex(rgbArray[1]) + rgbToHex(rgbArray[2]);

      cookie.set('invention_chroma_key_color', state.chroma_key_color, { expires: '3Y' });
    },
    chroma_key_sensitivity(state, sensitivity) {
      state.chroma_key_sensitivity = sensitivity;

      cookie.set('invention_chroma_key_sensitivity', state.chroma_key_sensitivity, { expires: '3Y' });
    },
    pusherGreenScreenInitiated(state, value) {
      state.pusherGreenScreenInitiated = value;
    },
    pusherTabletInitiated(state, value) {
      state.pusherTabletInitiated = value;
    },
    invention_app_inited(state, value) {
      state.invention_app_inited = value;
    }
  },
  actions: {
  },
  modules: {
  }
});
